module.exports = __webpack_public_path__ + "media/jinfucloud_index.4f7e2f98.mp4";